import { FC, ReactNode } from 'react';
import { XlsOchXlsxFilResponse } from '../../types/media';
import { ContentResponse } from '../../types/shared';

interface IXlsOchXlsxFil {
  contentResponse: ContentResponse;
}

const XlsOchXlsxFil: FC<IXlsOchXlsxFil> = ({ contentResponse }): ReactNode => {
  const contentResponseXls = contentResponse.content as XlsOchXlsxFilResponse;

  return <a href={contentResponseXls.relativeSourceUrl} download>{contentResponse.name}</a>;
};

export default XlsOchXlsxFil;
